import { coaches } from './coaches'

export type Testimonial = {
  quote: string
  author: string
  role: string
  avatar: string
}

/**
 * SAMPLE COPY — draft quotes written in the buyer's own language (VOC) to
 * show the angle each review should cover. Replace every quote with a real,
 * verifiable buyer review before launch (FTC + Meta ad review).
 */
export const shortTestimonials: Testimonial[] = [
  {
    quote:
      '[Sample] Sunday nights used to be three hours of programming. Now I open the day, read the page and go teach. That alone paid for it the first week.',
    author: coaches[0].name,
    role: coaches[0].role,
    avatar: coaches[0].avatar,
  },
  {
    quote:
      '[Sample] I had two big workout bundles sitting in my downloads. The problem was never workouts — it was picking one at 5 a.m. This just tells me.',
    author: coaches[1].name,
    role: coaches[1].role,
    avatar: coaches[1].avatar,
  },
  {
    quote:
      '[Sample] The Adaptation Matrix is the part I use most. Rain, 28 people instead of 12, no kettlebells — there is already an answer on the page.',
    author: coaches[2].name,
    role: coaches[2].role,
    avatar: coaches[2].avatar,
  },
]

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      '[Sample] The minute-40 scripts changed my classes. I finally have something to say when the room starts to fade, and my voice lasts the week.',
    author: coaches[3].name,
    role: coaches[3].role,
    avatar: coaches[3].avatar,
  },
  {
    quote:
      '[Sample] Mixed levels were my biggest headache. One session, three versions, and nobody gets left standing around.',
    author: coaches[4].name,
    role: coaches[4].role,
    avatar: coaches[4].avatar,
  },
  {
    quote:
      '[Sample] I bought it for the calendar and stayed for the retention toolkit. The re-activation scripts brought back clients I had written off.',
    author: coaches[0].name,
    role: coaches[0].role,
    avatar: coaches[0].avatar,
  },
]
